// src/modules/app-views/crm/pages/Kanban/boardSettingsRef.js
// Module-level ref to bridge the Kanban component's setShowBoardSettingsModal
// with the dropdown menu button (which doesn't have access to component state).
export const boardSettingsRef = { current: null };
